import React from 'react';
import { Stack, Box } from '@mui/material';
import { InputAutocompleteMulti, Text } from '@innovyze/stylovyze';
import { WEAVE_FONT } from '@Utils/fonts';

interface DefectCode {
	code: string;
	desc: string;
}

interface Props {
	defectCodes: DefectCode[];
}

export const DefectCodeFilter = ({ defectCodes }: Props) => {
	const options = defectCodes.map(code => ({
		key: code.code,
		value: code.desc,
	}));

	return (
		<Stack direction="row" spacing={3} alignItems="center" sx={{ mt: 2.5 }}>
			<Box sx={{ width: '160px', flexShrink: 0 }}>
				<Text variant="text-medium" sx={{ fontFamily: WEAVE_FONT }}>
					Defect Codes
				</Text>
			</Box>

			<InputAutocompleteMulti
				fieldAttrs={{ name: 'defectCodes' }}
				options={options}
				label="Defect Codes"
				textFieldProps={{
					required: false,
					sx: { minWidth: '120px', maxWidth: '848px' },
				}}
			/>
		</Stack>
	);
};
